import React from 'react';
import { cn } from '../../components/ui/Kit';
import { CHANNEL_VALUES, CHANNEL_LABELS, CHANNEL_COLORS } from '../../lib/leadMeta';

const SHORT_LABELS = { LD: 'LD', IM: 'IM', AM: 'AM' };

/**
 * Segmented channel control (LD / IM / AM).
 */
export default function ChannelSelector({
  value,
  onChange,
  allowEmpty = false,
  emptyLabel = 'All',
  hideAllChip = false,
  disabled = false,
  size = 'md',
  className,
}) {
  const chips = [];
  if (allowEmpty && !hideAllChip) {
    chips.push({ id: '', label: emptyLabel, color: '#9CA3AF' });
  }
  for (const id of CHANNEL_VALUES) {
    chips.push({
      id,
      label: SHORT_LABELS[id] || id,
      fullLabel: CHANNEL_LABELS[id],
      color: CHANNEL_COLORS[id],
    });
  }

  const height = size === 'sm' ? 'h-8 text-xs' : 'h-10 text-sm';

  return (
    <div
      className={cn('inline-flex flex-wrap gap-1 p-1 bg-gray-100 rounded-lg', className)}
      role="group"
      aria-label="Business channel"
    >
      {chips.map((opt) => {
        const selected = (value || '') === opt.id;
        const isChannel = CHANNEL_VALUES.includes(opt.id);
        return (
          <button
            key={opt.id || 'empty'}
            type="button"
            disabled={disabled}
            title={opt.fullLabel || opt.label}
            onClick={() => onChange(opt.id || null)}
            className={cn(
              'px-3 rounded-md font-medium transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 disabled:opacity-50',
              height,
              selected ? 'text-white shadow-sm' : 'text-gray-600 hover:text-gray-900 hover:bg-white/60',
            )}
            style={selected ? { backgroundColor: isChannel ? opt.color : '#6B7280' } : undefined}
            aria-pressed={selected}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
